import React from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

const SortDropDown = props => {
  const {
    sortOptions,
    setOpenSortDropdown,
    handleSort,
    sortDropdownOpen,
    setSelectedOption,
    selectedOption,
    className,
  } = props;

  const clickHandler = opt => {
    handleSort(opt);
    setOpenSortDropdown(false);
    setSelectedOption(opt);
  };

  const sortTitleClassName = () => {
    const activeSortType = className.includes('lists') ? 'lists' : 'folders';
    if (activeSortType === 'lists' && selectedOption?.length > 17) {
      return `sort-${activeSortType}-drop-down-long`;
    } else if (selectedOption?.length < 12) {
      return `sort-${activeSortType}-drop-down-short`;
    } else if (selectedOption?.length > 12 && selectedOption?.length < 18) {
      return `sort-${activeSortType}-drop-down-medium`;
    } else {
      return `sort-${activeSortType}-drop-down-medium`;
    }
  };
  return (
    <div className={`${className} ${sortDropdownOpen ? 'open' : ''} ${sortTitleClassName()}`}>
      {sortOptions.map(opt => (
        <div
          key={opt}
          className="do-not-close-dropdown sort-option"
          onClick={() => clickHandler(opt)}
        >
          <FontAwesome
            className="do-not-close-dropdown sort-check"
            name={`check-circle ${selectedOption === opt ? 'complete' : 'incomplete'}`}
          />
          <span className="do-not-close-dropdown sort-option-title">{opt}</span>
        </div>
      ))}
    </div>
  );
};

SortDropDown.propTypes = {
  sortOptions: propTypes.array,
  setOpenSortDropdown: propTypes.func,
  handleSort: propTypes.func,
  setSelectedOption: propTypes.func,
  selectedOption: propTypes.string,
  className: propTypes.string,
  sortDropdownOpen: propTypes.bool,
};

export default SortDropDown;
